(function($, exports) {


	exports.init = function() {
		var $toggle = $('.search-toggle');
		var $body = $('body');
		var $searchForm = $('.c-search__form');

		$toggle.on('click', function() {
			
			if(!$body.hasClass('is-open-search')) {
				setTimeout(function() {
		        	$searchForm.focus()
		       	}, 100);
			}

			$body.toggleClass('is-open-search');
		});

		$('html').on('click', function(e) {

			if(!$(e.target).closest('.c-search__form').length && !$(e.target).closest('.search-toggle').length) {  
				$body.removeClass('is-open-search');
			} 
			
		});
	};
	
})(jQuery, this.SEARCHTOGGLE = {});